import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useHealth } from "@/context/HealthContext";
import { HCard } from "@/components/health-kit";
import { ScrollText } from "lucide-react";

const TYPE_TONE = {
  ai_analysis_generated: "text-cyan-400", potential_signal_generated: "text-orange-400",
  professional_opened: "text-slate-300", professional_reviewed: "text-teal-400",
  professional_approve: "text-emerald-400", professional_correct: "text-teal-400",
  professional_reject: "text-red-400", professional_note: "text-blue-300",
};

export default function AuditTrail() {
  const { ht, tick } = useHealth();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/health/audit").then(({ data }) => setItems(data)).catch(() => {}); }, [tick]);

  return (
    <div className="space-y-6 ngx-fade-in" data-testid="health-audit">
      <div>
        <h1 className="font-display text-2xl font-bold text-slate-50">{ht("auditTrail")}</h1>
        <p className="text-sm text-slate-400 mt-1">{ht("auditSub")}</p>
      </div>
      <HCard className="p-0 overflow-hidden">
        <div className="grid grid-cols-[90px_1fr_130px_110px] px-4 h-10 items-center border-b border-slate-800 text-[10px] font-semibold uppercase tracking-widest text-slate-500">
          <span>{ht("timestamp")}</span><span>{ht("event")}</span><span>{ht("actor")}</span><span>{ht("patientId")}</span>
        </div>
        <div className="divide-y divide-slate-800/50 max-h-[68vh] overflow-y-auto" data-testid="audit-list">
          {items.map((a) => (
            <div key={a.id} className="grid grid-cols-[90px_1fr_130px_110px] px-4 py-2.5 items-center text-xs font-mono">
              <span className="text-slate-500">{a.time}</span>
              <span className={TYPE_TONE[a.type] || "text-slate-300"}>{ht("at_" + a.type)}{a.extra ? ` — ${a.extra}` : ""}</span>
              <span className="text-slate-400 truncate">{a.actor}</span>
              <span className="text-slate-500">{a.patient_id}</span>
            </div>
          ))}
          {items.length === 0 && <div className="py-16 text-center text-slate-500"><ScrollText className="h-8 w-8 mx-auto mb-3 text-slate-600" /><p className="text-sm">{ht("auditEmpty")}</p></div>}
        </div>
      </HCard>
    </div>
  );
}
